import _ from 'lodash';
import moment from 'moment';

import { IUser } from '../store/UserSlice';
import { IRolePermissions } from '../store/V2/RolesSlice';
import { ICourseTutor } from '../store/V2/CourseTutorsSlice';
import { ITenant } from '../store/V2/TenantsSlice';

export const checkUserRolePermissionOnly = (data: {
  authUser?: IUser;
  permissions: IRolePermissions;
}) => {
  const { authUser, permissions } = data;

  let hasRolePermission = false;

  if (authUser && permissions && authUser.role && authUser.role.permissions) {
    _.map(permissions, (permission, module) => {
      if (
        authUser.role &&
        authUser.role.permissions &&
        authUser.role.permissions[module] &&
        _.intersection(authUser.role.permissions[module], permission).length > 0
      ) {
        hasRolePermission = true;
      }
    });
  }

  return hasRolePermission;
};

export const checkTenantPermissionOnly = (data: {
  tenant?: ITenant;
  permissions: IRolePermissions;
}) => {
  const { tenant, permissions } = data;

  let hasTenantPermission = false;

  if (tenant && permissions && tenant.permissions) {
    _.map(permissions, (permission, module) => {
      if (
        tenant.permissions &&
        tenant.permissions[module] &&
        _.intersection(tenant.permissions[module], permission).length > 0
      ) {
        hasTenantPermission = true;
      }
    });
  }

  return hasTenantPermission;
};

export const checkUserPermission = (data: {
  tenant?: ITenant;
  authUser?: IUser;
  permissions: IRolePermissions;
}): boolean => {
  const { tenant, authUser, permissions } = data;

  const hasRolePermission = checkUserRolePermissionOnly({
    authUser,
    permissions,
  });

  const hasTenantPermission = checkTenantPermissionOnly({
    tenant,
    permissions,
  });

  return hasRolePermission && hasTenantPermission;
};

export const checkIsUser = (authUser: IUser | undefined): boolean => {
  if (
    authUser &&
    authUser.role &&
    (authUser.role.name === 'Student' ||
      authUser.role.name === 'Tutor' ||
      authUser.role.name === 'Guest')
  ) {
    return true;
  }

  return false;
};

export const isCourseTutorEligibleForClass = (
  courseTutor: ICourseTutor,
  classDate: string,
  classDurationMinutes: number
) => {
  let isEligible = false;

  if (courseTutor.status === 'ENABLE') {
    if (!courseTutor.startDate && !courseTutor.endDate) {
      isEligible = true;
    } else {
      const dateTime = moment(classDate);
      const classEndTime = dateTime
        .clone()
        .add(classDurationMinutes, 'minutes');

      if (courseTutor.startDate && courseTutor.endDate) {
        const startDate = moment(courseTutor.startDate).startOf('day');
        const endDate = moment(courseTutor.endDate).endOf('day');

        if (
          dateTime >= startDate &&
          dateTime <= endDate &&
          classEndTime <= endDate
        ) {
          isEligible = true;
        }
      } else if (courseTutor.startDate) {
        const startDate = moment(courseTutor.startDate).startOf('day');

        if (dateTime.isSameOrAfter(startDate)) {
          isEligible = true;
        }
      } else if (courseTutor.endDate) {
        const endDate = moment(courseTutor.endDate).endOf('day');

        if (
          dateTime.isSameOrBefore(endDate) &&
          classEndTime.isSameOrBefore(endDate)
        ) {
          isEligible = true;
        }
      }
    }
  }

  return isEligible;
};
